import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette }) =>
  createStyles({
    container: {
      position: 'relative',
    },

    months: {
      display: 'flex',
      border: '1px solid #727970',
      borderRadius: 4,

      overflow: 'hidden',
      marginBottom: '0.8rem',

      '& > div': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',

        height: 36,

        textTransform: 'capitalize',

        '&[data-is-selected="true"]': {
          backgroundColor: '#E2E2E2',
        },

        '&:not(:last-child)': {
          borderRight: 'inherit',
        },

        '& > span:first-child': {
          fontSize: '1.8rem',
          fontWeight: 600,
        },

        '& > span:nth-child(2)': {
          fontSize: '1.2rem',
          marginTop: '0.4rem',
        },
      },
    },

    arrowButtons: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',

      position: 'absolute',
      top: 32,
      left: -10,
      right: -10,

      '& > button': {
        backgroundColor: palette.secondary.main,
        borderRadius: '4px',
        color: 'white',

        '& svg': {
          fontSize: '1.4rem',
        },

        '&:hover': {
          backgroundColor: palette.text.primary,
        },
      },
    },

    weeks: {
      display: 'flex',
      border: '1px solid #727970',
      borderRadius: 4,
      height: 24,

      '& > span': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,

        fontSize: '1.2rem',
        fontWeight: 600,

        '&:not(:last-child)': {
          borderRight: 'inherit',
        },
      },
    },

    days: {
      display: 'flex',
      height: 36,

      '& > span': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        flex: 1,

        fontSize: '1.2rem',
        fontWeight: 600,

        color: '#C3C3C3',
      },
    },
  }),
)
